module.exports = __webpack_public_path__ + "img/circle-3.1088af62.png";